import { useState } from 'react'
import Slider from 'react-animated-slider'

import { CIVILISATION_LIST } from '../../app/constants'
import { rightArrow, leftArrow } from '../../assets/img'
import AllianceVideo from '../../assets/videos/Alliance.mp4'
import AxolotlVideo from '../../assets/videos/Axolotl.mp4'
import LuminayaVideo from '../../assets/videos/Luminaya.mp4'
import PurgamenVideo from '../../assets/videos/Purgamen.mp4'
import RazatechVideo from '../../assets/videos/Razatech.mp4'
import { CivilisationTitle } from '../containers/CivilisationTitle'
import { Container } from '../containers/Container'
import { SliderContent } from '../containers/SliderContent'

export const RazatechSlider = ({ component, vertical }) => {
  const [isInMission, setIsInMission] = useState(false)

  return (
    <Slider
      slideIndex={4}
      touchDisabled={false}
      previousButton={leftArrow()}
      nextButton={rightArrow()}
      className="slider h-full"
    >
      {CIVILISATION_LIST.slice(
        0,
        !(component === 'collection') ? -1 : CIVILISATION_LIST.length,
      ).map((civilisation, i) => (
        <div key={i} className="flex justify-center min-w-full">
          <Container vertical={vertical} type={component}>
            <CivilisationTitle
              vertical={vertical}
              civilisation={civilisation}
            />
            {(!isInMission || component) !== 'missionDayThree' && (
              <SliderContent
                component={component}
                civilisation={civilisation}
              />
            )}

            {isInMission && component === 'missionDayThree' && (
              <div className="w-full h-full">
                <video
                  autoPlay
                  src={
                    civilisation === 'Alliance'
                      ? AllianceVideo
                      : civilisation === 'Luminayan'
                      ? LuminayaVideo
                      : civilisation === 'Axolotl'
                      ? AxolotlVideo
                      : civilisation === 'Razatech'
                      ? RazatechVideo
                      : PurgamenVideo
                  }
                  muted
                  loop
                  width="100%"
                  height="100%"
                >
                  Sorry, your browser doesn't support videos.
                </video>
              </div>
            )}
          </Container>
        </div>
      ))}
    </Slider>
  )
}
